import React from 'react'
import Helmet from 'react-helmet'

import { Page, Section } from '../components/common'
import FeedbackForm from '../components/FeedbackForm'
import Header from '../components/Header'

const LeaveFeedback = props => {
  return (
    <Page light>
      <Helmet title='Leave Feedback' />
      <Header small title='Leave Feedback' />
      <Section thin>
        <FeedbackForm />
      </Section>
    </Page>
  )
}

export default LeaveFeedback



// WEBPACK FOOTER //
// ./src/views/LeaveFeedback.js